<mat-form-field style="width: 100%">
  <mat-label>{{'talent-happy-path.labels.date' | translate}}</mat-label>
  <input hidden matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" />
  <span>{{this.formattedDate}}</span>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker touchUi #picker>
    <mat-datepicker-actions class="datepicker-action-button">
      <button mat-button matDatepickerCancel>{{'talent-happy-path.buttons.cancel' | translate}}</button>
      <button mat-button matDatepickerApply (click)="onDateChange(picker)">{{'talent-happy-path.buttons.ok' | translate}}</button>
    </mat-datepicker-actions>
  </mat-datepicker>
</mat-form-field>

